import type { ChartData, DynamicsData, KpiItem, PriceDetailsItem, TableRow } from "./types";
import type { FilterOptions } from "./types";

export const TEST_AVERAGE_TABLE: TableRow[] = [
  { date: "15.12.2025", client: 5900, competitor: 8368, diffPercent: 41.8 },
  { date: "14.12.2025", client: 5900, competitor: 7427, diffPercent: 25.9 },
  { date: "13.12.2025", client: 8260, competitor: 7718, diffPercent: -6.6 },
  { date: "12.12.2025", client: 5900, competitor: 8954, diffPercent: 51.8 },
  { date: "11.12.2025", client: null, competitor: 8484, diffPercent: null },
  { date: "10.12.2025", client: 6000, competitor: 8000, diffPercent: 33.3 },
  { date: "09.12.2025", client: 8120, competitor: 7700, diffPercent: -5.2 },
  { date: "08.12.2025", client: 5700, competitor: 7500, diffPercent: 31.6 },
  { date: "07.12.2025", client: 5600, competitor: 7400, diffPercent: 32.1 },
  { date: "06.12.2025", client: 5500, competitor: 7200, diffPercent: 30.9 },
];

export const TEST_MIN_TABLE: TableRow[] = [
  { date: "15.12.2025", client: 5100, competitor: 4800, diffPercent: -5.9 },
  { date: "14.12.2025", client: 5100, competitor: 5520, diffPercent: 8.2 },
  { date: "13.12.2025", client: 7460, competitor: 4700, diffPercent: -37.0 },
  { date: "12.12.2025", client: 5100, competitor: 5000, diffPercent: -2.0 },
  { date: "11.12.2025", client: null, competitor: 4900, diffPercent: null },
  { date: "10.12.2025", client: 5200, competitor: 4800, diffPercent: -7.7 },
  { date: "09.12.2025", client: 7320, competitor: 4700, diffPercent: -35.8 },
  { date: "08.12.2025", client: 5000, competitor: 4600, diffPercent: -8.0 },
  { date: "07.12.2025", client: 5000, competitor: 5688, diffPercent: 13.8 },
  { date: "06.12.2025", client: 5000, competitor: 5850, diffPercent: 17.0 },
];

export const TEST_CHART_DATA: ChartData = {
  dates: ["06.12", "07.12", "08.12", "09.12", "10.12", "11.12", "12.12", "13.12", "14.12", "15.12"],
  series: [
    { name: "Клиент (минимальное)", data: [5200, 5100, 5000, 7400, 6200, 6000, 5900, 7300, 5600, 5100], style: "dashed" },
    { name: "Клиент (среднее)", data: [5600, 5700, 5800, 8200, 6100, 6000, 6300, 8500, 5900, 6200] },
    { name: "Клиент (максимальное)", data: [6700, 6900, 7100, 11100, 7200, 7100, 7000, 10000, 7400, 7200] },
    { name: "Конкуренты (минимальное)", data: [5900, 5700, 4600, 4800, 4900, 5000, 4700, 4500, 5600, 4800], style: "dashed" },
    { name: "Конкуренты (среднее)", data: [7200, 7400, 7600, 7800, 8000, 8200, 9000, 8200, 7600, 8400] },
    { name: "Конкуренты (максимальное)", data: [8000, 8200, 8300, 8600, 8800, 9000, 9800, 8400, 8200, 9500] },
  ],
};

export const TEST_MIN_DYNAMICS: DynamicsData = {
  dates: ["11.02", "12.02", "13.02", "14.02", "15.02", "16.02", "17.02"],
  rows: [
    { name: "Azimut Отель Тамбов", values: [4532, 4532, 4532, 4532, 4532, 4532, 4532], isClient: true },
    { name: "Белгравия", values: [5592, 5592, 5592, 5592, 5614, 5614, 5544] },
    { name: "Гостиница Державина", values: [5283, 5283, 5283, 5283, 5137, 5137, 5137] },
    { name: "Гостиница Париж", values: [5000, 5000, 5000, 5000, 5000, 5000, 5000] },
    { name: "Гранд Тамбов", values: [5320, 5320, 5320, 5320, 5320, 5320, 5320] },
  ],
};

export const TEST_AVG_DYNAMICS: DynamicsData = {
  dates: ["11.02", "12.02", "13.02", "14.02", "15.02", "16.02", "17.02"],
  rows: [
    { name: "Azimut Отель Тамбов", values: [6230, 6200, 6210, 6250, 6270, 6290, 6320], isClient: true },
    { name: "Белгравия", values: [7010, 7020, 7030, 7060, 7040, 7030, 7050] },
    { name: "Гостиница Державина", values: [6680, 6700, 6720, 6750, 6730, 6740, 6760] },
    { name: "Гостиница Париж", values: [6400, 6420, 6450, 6480, 6460, 6450, 6470] },
    { name: "Гранд Тамбов", values: [6600, 6620, 6630, 6650, 6640, 6660, 6680] },
  ],
};

export const TEST_PRICE_DETAILS_MIN: PriceDetailsItem[] = [
  {
    hotelId: "1",
    hotelName: "Azimut Сити Отель Олимпик Москва",
    roomKey: "101",
    roomName: "Апартаменты",
    isBase: true,
    category: "apartament",
    prices: { yandex: 20000, tinkoff: 20000, ostrovok: 20000, sutochno: 20000, traveline: 20000 },
  },
  {
    hotelId: "2",
    hotelName: "Azimut Сити Отель Олимпик Москва",
    roomKey: "102",
    roomName: "Люкс A",
    isBase: true,
    category: "luxe",
    prices: { yandex: 15350, tinkoff: 15300, ostrovok: 15300, sutochno: 15300, traveline: 15300 },
  },
  {
    hotelId: "3",
    hotelName: "City Boutique",
    roomKey: "201",
    roomName: "Designer Luxe",
    isBase: false,
    category: "luxe",
    prices: { yandex: 15500, tinkoff: 15500, ostrovok: 15500, sutochno: 15500, traveline: 15500 },
  },
  {
    hotelId: "4",
    hotelName: "City Boutique",
    roomKey: "202",
    roomName: "Rooftop Suite",
    isBase: false,
    category: "luxe",
    prices: { yandex: 14200, tinkoff: 14200, ostrovok: 14500, sutochno: 14200, traveline: 14200 },
  },
  {
    hotelId: "5",
    hotelName: "Grand Palace Hotel",
    roomKey: "301",
    roomName: "Family Suite (4 pax)",
    isBase: false,
    category: "luxe",
    prices: { yandex: 14000, tinkoff: 14000, ostrovok: 14000, sutochno: 14000, traveline: 14000 },
  },
  {
    hotelId: "6",
    hotelName: "Grand Palace Hotel",
    roomKey: "302",
    roomName: "Presidential Deluxe",
    isBase: false,
    category: "luxe",
    prices: { yandex: 16900, tinkoff: 16900, ostrovok: 17500, sutochno: 16900, traveline: 16900 },
  },
  {
    hotelId: "7",
    hotelName: "Hotel Riviera",
    roomKey: "401",
    roomName: "Panorama Suite with City View",
    isBase: false,
    category: "luxe",
    prices: { yandex: 14850, tinkoff: 15000, ostrovok: 15500, sutochno: 15800, traveline: 14850 },
  },
  {
    hotelId: "8",
    hotelName: "Mountain Lodge",
    roomKey: "501",
    roomName: "Alpine Suite",
    isBase: false,
    category: "luxe",
    prices: { yandex: 19200, tinkoff: 19200, ostrovok: 19200, sutochno: 19200, traveline: 19200 },
  },
];

export const TEST_PRICE_DETAILS_AVG: PriceDetailsItem[] = TEST_PRICE_DETAILS_MIN.map((item, index) => ({
  ...item,
  roomKey: `${item.roomKey}-avg`,
  prices: Object.fromEntries(
    Object.entries(item.prices).map(([platform, value]) => [
      platform,
      typeof value === "number" ? value + 400 + index * 60 : value,
    ]),
  ),
}));

export const TEST_KPI: KpiItem[] = [
  {
    label: "Средняя дельта",
    value: "+1 487",
    suffix: "(+23.5%)",
    tone: "text-emerald-600",
    description: "к средним ценам конкурентов",
    accent: "emerald",
  },
  {
    label: "Средняя цена клиента",
    value: "6 320",
    description: "по выбранному периоду",
    accent: "indigo",
  },
  {
    label: "Средняя цена конкурентов",
    value: "7 807",
    description: "по выбранному периоду",
    accent: "violet",
  },
  {
    label: "Дней когда конкурент выше/ниже",
    badges: [
      { label: "Выше: 7", className: "bg-emerald-50 text-emerald-700" },
      { label: "Ниже: 2", className: "bg-rose-50 text-rose-700" },
    ],
    description: "дней с отклонением",
    accent: "amber",
  },
];

export const TEST_FILTER_OPTIONS: FilterOptions = {
  dataSource: [
    { label: "Автосбор", value: "auto" },
    { label: "Ручной ввод", value: "manual" },
    { label: "Импорт файла", value: "import" },
  ],
  category: [
    { label: "Стандарт", value: "standard" },
    { label: "Комфорт", value: "comfort" },
    { label: "Люкс", value: "suite" },
  ],
  ota: [
    { label: "Booking", value: "booking" },
    { label: "Ostrovok", value: "ostrovok" },
    { label: "Yandex Travel", value: "yandex" },
  ],
  meals: [
    { label: "Завтрак включен", value: "breakfast" },
    { label: "Полупансион", value: "half" },
    { label: "Без питания", value: "none" },
  ],
  refund: [
    { label: "Бесплатная отмена", value: "free" },
    { label: "Невозвратный", value: "nonref" },
  ],
  payment: [
    { label: "Онлайн", value: "online" },
    { label: "На месте", value: "onsite" },
    { label: "По счету", value: "invoice" },
  ],
  competitors: [
    { label: "Mövenpick Resort", value: "movenpick" },
    { label: "Zenith Resort", value: "zenith" },
  ],
  room: [
    { label: "Стандарт 2-местный", value: "std2" },
    { label: "Делюкс", value: "deluxe" },
    { label: "Семейный", value: "family" },
  ],
};

export const TEST_CHECK_IN_RANGE = {
  from: "2025-12-06",
  to: "2025-12-15",
};

export const TEST_HOTELS = [
  { label: "Отель Пушкин", value: "pushkin" },
  { label: "Гранд Нева", value: "neva" },
  { label: "Сити Лайф", value: "citylife" },
];
